import { VisitorIdTypes } from './constants';

export const VARIANT_ON = 'on';
export const VARIANT_OFF = 'off';

export const FULL_STORY = {
    experimentId: 'FullStory',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const FULL_STORY_BOOKING = {
    experimentId: 'FullStory-Booking',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const PINA_REMEMBER_ME = {
    experimentId: 'Pina_ExtendedSession_ShowRememberMe',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

// Static (Accordion) Review and book with new/existing validation for certain
// users
export const PCE_STATIC_WITH_NEW_EXISTING_VALIDATION = {
    experimentId: 'PCE_StaticWithNewExistingValidation',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
    recordManually: true,
};

export const ALLOW_GOVERNMENT_INSURANCE = {
    experiment: 'Choco_MasterFlag_AllowGovernmentInsurance',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.SESSION_ID,
};

export const VIRTUAL_VISITS = {
    experimentId: 'EnableVideoVisitsWithZocdocProvidersForPatients',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const ENABLE_ZOCDOC_VIDEO_VISIT_LOCATIONS = {
    experimentId: 'EnableZocdocVideoVisitLocations',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PINA_BOOKING_COMPLETE_WARP_SPEED = {
    experimentId: 'Pina_BookingComplete_WarpSpeed',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const BWA_SUPPRESS_SSO = {
    experimentId: 'BWA_SuppressSso',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PCE_SIGN_IN_FACEBOOK_SSO = {
    experimentId: 'PCE_SignInFacebookSso',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};
export const PCE_SIGN_IN_GOOGLE_SSO = {
    experimentId: 'PCE_SignInGoogleSso',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};
export const PCE_SIGN_IN_APPLE_SSO = {
    experimentId: 'PCE_SignInAppleSso',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};
export const PINA_BOOKING_COMPLETE_POBOLO = {
    experimentId: 'Pina_BookingComplete_Pobolo',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PCE_MENTAL_HEALTH_OON_BENEFITS = {
    experimentId: 'pce_mental_health_oon_benefits',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    recordManually: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP = {
    experimentId: 'pinata_email_first_login_and_signup',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PCE_ENABLED_VACCINE_TRANSLATION = {
    experimentId: 'PCE_EnableVaccineTranslation',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const PINATA_MFA_AUTH = {
    experimentId: 'pinata_mfa_auth',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const ADD_DD_SCRIPTS = {
    experimentId: 'Add_DD_Scripts',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const ADD_DD_SCRIPTS_BWA = {
    experimentId: 'Add_DD_Scripts_BWA',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const REMOVE_MEMBER_ID_OPTIONAL = {
    experimentId: 'pinata_remove_optional_copy_member_id',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const REQUIRE_MEMBER_ID = {
    experimentId: 'pinata_require_member_id',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const REVIEW_AND_BOOK_INSURANCE_SCANNER = {
    experimentId: 'pinata_review_and_book_insurance_scanner',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

export const OUT_OF_STATE_VIDEO_VISIT = {
    experimentId: 'pinata_out_of_state_video_visit',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};

// NOTE: Do not remove. This flag is being used in FEC
export const EAT_SITE_FOOTER_CONTACT_INFO = {
    experimentId: 'EAT_siteFooterContactInfo',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

// NOTE: Do not remove. This flag is being used in FEC
export const API_DOCS_LINK_IN_FOOTER = {
    experimentId: 'api_docs_link_in_footer',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const PINATA_REDIRECT_FROM_WELL_GUIDE_TO_PATIENTHOME = {
    experimentId: 'pinata_tear_down_well_guide',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: VisitorIdTypes.TRACKING_ID,
};
